<template>
  <div class="lh_container">
    <v-p-top @showResult="onShowResult"
             @end="handle_end"
             :phase="phase"
             :next_phase="next_phase"
             :records="records"
             :name="head.title"
             :remain_time="remain_time"
             :block_time="block_time"
             @change="changeFp"
    >
      <ul slot="recodeNumber" class="num_record lh_num_record">
        <li v-for="(item, index) in records" :key="'re' + index" class="item lh_item" :style="{ 'width': index==6 ? '60px' : '' }">
          <span v-if="index==6">+</span>
          <span class="number" :class="filterNumberColor(item.number)">{{ item.number }}</span>
          <span>{{ item.value }}</span>
        </li>
      </ul>
    </v-p-top>

    <template v-if="!$route.query.notice">
      <v-tab class="page-tabs" v-if="tabs.length" :current="tabs[curTab].value" @onChangeTab="onLHTabChange"
             :tabs="tabs"
             :border="true"></v-tab>

      <div class="lh-main page-wrapper" :style="contentStyleObj">

        <!--<v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected"
                   @onQuickCreate="handleQuickCreate"
        />-->

        <!-- inner-tab -->
        <component :chip="chip.toString()" ref="c_model_input" :is="componentsName" class="component-page"
                   :data="tabPageData"
                   :current="current"
                   @reset="reset_selected"
                   @onRestValue="onRestValue"
        ></component>
        <!-- inner-tab end -->

        <v-c-input @again="handle_again" class="c-input" v-model="chip" @certain="certain_handle"
                   @reset="reset_selected"
                   @onQuickCreate="handleQuickCreate"
        />

        <v-statistic @showRule="onShowRule" class="page-side" @onQuickCreate="handleQuickCreate"></v-statistic>

      </div>
      <order ref="order" @submit="order_sub" :orders="orders" :order_subing="order_subing"/>
    </template>
    <!--<template>
      <div class="listen">
        <audio controls="controls" hidden id="audio1">
          <source src="../../../assets/1.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio2">
          <source src="../../../assets/2.mp3" type="audio/mpeg"/>
        </audio>
        <audio controls="controls" hidden id="audio3">
          <source src="../../../assets/3.mp3" type="audio/mpeg"/>
        </audio>
      </div>
    </template>-->
  </div>
</template>

<script>
import methods from '../methods';
import objectPath from 'object-path';
import { mapState, mapActions } from 'vuex';
import Order from '../../../components/dialog/order';
import VPTop from '../../../components/c_top';
import VSelect from '../../../components/c_select';
import VStatistic from '../../../components/c_statistics';
import VTab from '../../../components/c_tab';
import VCInput from '../../../components/c_a-input';
import DH110 from '../../../components/pageComponents/lh/dh1-10';
import GYH from '../../../components/pageComponents/lh/gyh';
import GYZH from '../../../components/pageComponents/lh/gyzh';
import TAB from '../../../components/pageComponents/lh/tab';
import BANBO from '../../../components/pageComponents/lh/banbo';
import ZONGXIAO from '../../../components/pageComponents/lh/zongxiao';
import TEXIAOSHOUWEI from '../../../components/pageComponents/lh/texiaoshouwei';
import eventMixin from '../../../utils/eventMixin';
import { computedDataLH } from '../../../utils/lhComputed';
import { filterNumber } from "../../../utils/objectFactory";

const each = (cb, el) => {
  (el.name === 'g_input_selected_item' || el.name === 'g_input_selected_item_type_2') && cb(el);
  if (el.$children.length > 0) el.$children.forEach(child => each(cb, child));
};

export default {
  name: "lh",
  mixins: [eventMixin, methods],
  components: {
    Order,
    VTab,
    VPTop,
    VSelect,
    VCInput,
    VStatistic,
    DH110,
    TAB,
    GYH,
    GYZH,
    BANBO,
    ZONGXIAO,
    TEXIAOSHOUWEI
  },
  computed: {
    // 封盘倒计时
    remain_time() {
      return this.lottery.next_info.remain_time;
    },
    block_time() {
      return this.lottery.next_info.block_time;
    },
    next_phase() {
      return this.lottery.next_info.period;
    },
    // 期数
    phase() {
      return this.lottery.latest_result.period;
    },
    /*have_next() {
      return this.lottery.next_info.have_next;
    },*/
    // 开奖号码
    records() {
      const number = objectPath.get(this.lottery, 'latest_result.number');
      const shengxiao = objectPath.get(this.lottery, 'latest_result.shengxiao');
      const DEFAULT_DATA = [];
      if (number) {
        const DEFAULT_SHENGXIAO = shengxiao.split(',');
        number.split(',').forEach((item, index) => {
          const value = objectPath.get(DEFAULT_SHENGXIAO, `${index}`);
          DEFAULT_DATA.push({
            number: item,
            value
          })
        });
      }
      return DEFAULT_DATA;
    },
    ...mapState({
      curTab: state => state.home_PK10.curTab,
      headTabs: state => state.home.headTabs,
      tabs: state => state.home_PK10.tabs,
      odds: state => state.home_PK10.odds,
      lottery: state => state.home_PK10.lottery,
      order_history: state => state.home_PK10.order_history,
      longQueue: state => state.home.longQueue,
      playTypeRadio: state => state.home.playTypeRadio,
      playDantuoTotal: state => state.home.playDantuoTotal,
      shengxiaoData: state => state.home_PK10.shengxiaoData,
      statistics: state => state.home.statistics,
    }),
    current() {
      return this.tabs[this.curTab] || null;
    },
    head() {
      return this.headTabs.find(item => item.lottery_type == this.$route.query.lottery_type) || {};
    },
    // 组件名称
    componentsName() {
      let _name = 'g-y-z-h';
      const value = objectPath.get(this.current, 'value');
      switch (value) {
        case 1:
        case 2:
        case 3:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 11:
        case 12:
        case 13:
          _name = 't-a-b';
          break;
        // 特肖首尾
        case 4:
          _name = 't-e-x-i-a-o-s-h-o-u-w-e-i';
          break;
        // 总肖
        case 10:
          _name = 'z-o-n-g-x-i-a-o';
          break;
        // 半波
        case 14:
        case 15:
          _name = 'b-a-n-b-o';
          break;
      }
      return _name;
    },
    tabPageData() {
      const odds = this.odds.map(item => {
        if (!item._status) item._status = item.status;
        if (!this.time) {
          item.status = 3;
        } else if (item.status === 3) {
          item.status = item._status;
        }
        return item;
      });
      const data = computedDataLH(odds, this.current, this.shengxiaoData, this.playTypeRadio);
      return data;
    }
  },
  data() {
    return {
      origin_list: null,
      // 最后选择的订单号
      orders: [],
      order_subing: false,

      // 连码选择
      curInnerTab: 0,
      // 筹码
      chip: '',

      // 封盘&&倒计时
      time: 0,
      contentStyleObj: {
        height: ''
      },
    }
  },
  methods: {
    ...mapActions({
      createOrder: 'home_PK10/createOrder',
      getNewLotteryRes: 'home_PK10/getNewLotteryRes',
      updateUserInfo: 'root/updateUserInfo',
      getLotteryLatest: 'home/getLotteryLatest',
      getLongQueue: 'home/getLongQueue',
      getStatistics: 'home/getStatistics',
      onSetLhItemTotal: 'home/onSetLhItemTotal',
    }),
    ...mapActions("table", {
      load_lh_shengxiao: "load_lh_shengxiao"
    }),
    // 切换玩法
    onLHTabChange(tab) {
      this.$store.dispatch("home_PK10/setPlayedName", '');
      this.onTabChanged(tab);
    },
    onRestValue() {
      this.$store.state.inputnum = '';
      this.$emit("input", "");
    },
    getHeight() {
      //this.contentStyleObj.height = window.innerHeight - 220 + 'px';
    },
    // 过滤出号码背景颜色
    filterNumberColor(checkNumber) {
      const isFilterNumber = filterNumber(checkNumber);
      if (isFilterNumber) {
        return isFilterNumber;
      }
      return '';
    },
  },
  created() {
    var lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        if (lett.$refs.order.showOrderDialog === true) {
          lett.$refs.order.handle_submit();
        } else {
          lett.certain_handle();
        }
      }
    }

    window.addEventListener('resize', this.getHeight);
    this.getHeight();
    // this.load_lh_shengxiao();
  },

}
</script>

<style scoped lang="stylus">
.lh_container
  .s_game-center
    margin-top 4px
    background-color #ffffff

.lh_num_record {
  display: flex;
  float: right;
  margin-right:10px;

  .lh_item {
    display: flex;
    align-items: center;
    width: 50px;
    margin-left: 0px !important;
  }

  .number {
    width: 30px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-size: contain;
    font-size: 13px;
    font-weight: bold;
    padding-bottom: 2px;
  }

  .number-blue {
    color:#0b0c0c;
    background: url('../../../assets/back_blue.png') no-repeat center center;
  }

  .number-green {
    color:#0b0c0c;
    background: url('../../../assets/back_green.png') no-repeat center center;
  }

  .number-red {
    color:#0b0c0c;
    background: url('../../../assets/back_red.png') no-repeat center center;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/lh/index.vue